var _mask, _path, _mask2, _path2, _mask3, _path3, _mask4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTournamentPlaceholder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_5740_96435",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6133 14.3226C23.6133 13.0399 24.6531 12 25.9359 12H70.0649C71.3476 12 72.3875 13.0399 72.3875 14.3226V46.8387C72.3875 59.6659 61.9889 70.0645 49.1617 70.0645H46.8391C34.0118 70.0645 23.6133 59.666 23.6133 46.8387V14.3226Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6133 14.3226C23.6133 13.0399 24.6531 12 25.9359 12H70.0649C71.3476 12 72.3875 13.0399 72.3875 14.3226V46.8387C72.3875 59.6659 61.9889 70.0645 49.1617 70.0645H46.8391C34.0118 70.0645 23.6133 59.666 23.6133 46.8387V14.3226Z",
    stroke: "black",
    strokeWidth: 10,
    mask: "url(#path-1-inside-1_5740_96435)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_5740_96435",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2578 82.1935C64.2578 83.1912 63.449 84 62.4514 84L33.5481 84C32.5505 84 31.7417 83.1912 31.7417 82.1936V82.1936C31.7417 74.2121 38.2119 67.7419 46.1933 67.7419L49.8062 67.7419C57.7876 67.7419 64.2578 74.2121 64.2578 82.1935V82.1935Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2578 82.1935C64.2578 83.1912 63.449 84 62.4514 84L33.5481 84C32.5505 84 31.7417 83.1912 31.7417 82.1936V82.1936C31.7417 74.2121 38.2119 67.7419 46.1933 67.7419L49.8062 67.7419C57.7876 67.7419 64.2578 74.2121 64.2578 82.1935V82.1935Z",
    stroke: "black",
    strokeWidth: 10,
    mask: "url(#path-2-inside-2_5740_96435)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_5740_96435",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2578 18.9678L28.2578 51.4839V51.4839C19.2787 51.4839 11.9997 44.2049 11.9997 35.2258L11.9997 21.2904C11.9997 20.0076 13.0396 18.9678 14.3223 18.9678L28.2578 18.9678Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2578 18.9678L28.2578 51.4839V51.4839C19.2787 51.4839 11.9997 44.2049 11.9997 35.2258L11.9997 21.2904C11.9997 20.0076 13.0396 18.9678 14.3223 18.9678L28.2578 18.9678Z",
    stroke: "black",
    strokeWidth: 9.29032,
    mask: "url(#path-3-inside-3_5740_96435)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_5740_96435",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.7422 18.9678L67.7422 51.4839V51.4839C76.7213 51.4839 84.0003 44.2049 84.0003 35.2258L84.0003 21.2904C84.0003 20.0076 82.9604 18.9678 81.6777 18.9678L67.7422 18.9678Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7422 18.9678L67.7422 51.4839V51.4839C76.7213 51.4839 84.0003 44.2049 84.0003 35.2258L84.0003 21.2904C84.0003 20.0076 82.9604 18.9678 81.6777 18.9678L67.7422 18.9678Z",
    stroke: "black",
    strokeWidth: 9.29032,
    mask: "url(#path-4-inside-4_5740_96435)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTournamentPlaceholder);
export default __webpack_public_path__ + "static/media/tournament-placeholder.7ed41e0ec44546352de63b80c6294e9c.svg";
export { ForwardRef as ReactComponent };